import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DevicesService } from '../../../services/devices.service';
import { DeviceTypeEnum } from '../../../enums/devices.enum';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AddLabelDialogComponent } from '../add-label/add-label-dialog.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-add-device-dialog',
  templateUrl: './add-device-dialog.component.html',
  styleUrls: ['./add-device-dialog.component.scss']
})
export class AddDeviceDialogComponent implements OnInit {
  public newDevice;
  public title: string;
  public name = new FormControl('', [Validators.required, Validators.pattern('.*[a-zA-Z0-9].*')]);
  public code = new FormControl('', [Validators.required, Validators.pattern('.*[a-zA-Z0-9].*')]);
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<AddDeviceDialogComponent>,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private devicesService: DevicesService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.data.type === DeviceTypeEnum.CLASS) {
      this.newDevice = { name: '', code: '', description: '', tags: [], devices: [] };
      this.title = this.translate.instant('ADD_DEVICE_DIALOG.COMPONENT.ADD_NEW_CLASS');
    } else {
      this.newDevice = { name: '', code: '', description: '', tags: [] };
      this.title = this.translate.instant('ADD_DEVICE_DIALOG.COMPONENT.ADD_NEW_DEVICE');
    }

    if (this.data.editingDevice) {
      this.newDevice.name = this.data.editingDevice.name;
      this.newDevice.code = this.data.editingDevice.code;
      this.newDevice.description = this.data.editingDevice.description;
      this.newDevice.tags = [...this.data.editingDevice.tags];
    }
  }

  save(): void {
    if (this.data.type === DeviceTypeEnum.CLASS) {
      this.isSubmitting = true;
      this.devicesService.createDevice(this.newDevice).subscribe(device => {
        this.dialogRef.close(device);
        this.isSubmitting = false;
      });
    } else {
      let deviceClass = this.data.deviceClass;

      if (!deviceClass.devices) {
        deviceClass.devices = [];
      }

      if (this.data.editingDevice) {
        deviceClass = {
          ...deviceClass,
          devices: deviceClass.devices.map(d => {
            if (this.data.editingDevice._id === d._id) {
              return {
                ...d,
                ...this.newDevice
              };
            }

            return d;
          })
        };
      } else {
        deviceClass.devices.push(this.newDevice);
      }
      this.isSubmitting = true;
      this.devicesService.updateDevice(deviceClass).subscribe(device => {
        this.dialogRef.close(deviceClass);
        this.isSubmitting = false;
      });
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }

  addLabel() {
    this.dialog
      .open(AddLabelDialogComponent)
      .afterClosed()
      .pipe(filter(v => !!v))
      .subscribe((label: string) => {
        this.newDevice.tags.push(label);
      });
  }

  removeTag(tag: any, array): void {
    const index = array.indexOf(tag);

    if (index >= 0) {
      array.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/devices/add-device/add-device-dialog.component.ts